import { doubleToStringMonthly } from "../../../objects/CommonUse/double_functions";
import BadgesInfoDataset from "../badgesDatasets/badges_info_dataset";

export const determineBadgeInfo = (badgeId, badgeSlctd, badgesEarned) => {
    let badgeName = "";
    let badgeDesc = "";
    let badgeType = "badge";
    let badgeAnimation = "badge";
    const badgeInfo = BadgesInfoDataset.find(elem => elem.badgeCode === badgeId);
    const badgeCode = badgeSlctd.id;
    const lastCharStart = badgeCode.length - 1;
    const lastCharEnd = badgeCode.length;
    const partNbr = badgeCode.substring(lastCharStart, lastCharEnd);
    let badgeTitle = badgeInfo.badgeName;
    if (badgeSlctd.earned === true || badgeSlctd.earned === "partial"){
        if (badgeSlctd.earned === true){
            badgeDesc = "Good Job!! You have earned this badge." //add badge reward info
        }else{
            badgeDesc = "You have earned part " + partNbr + " of this badge.  Click on the " +
                "'Badge Challenge' button to earn the remaining part of this badge.";
        }
    }else{
        badgeDesc = "If you earn this badge, it will increase your " + badgeInfo.awardType +
            ". You have not yet earned this badge.  Click on the " + 
            "'Badge Challenge' button to earn another badge.";
    }
    
    let awardAmount = 0;
    let awardType = "";
    let moodPoints = 0;
    const badgeArr = 
        badgesEarned.filter(elem => elem.badgeCode.slice(0, -1) === badgeSlctd.id.slice(0, -1));
    if (badgeArr){
        for (let i=0; i<badgeArr.length; i++){
            awardAmount += +badgeArr[i].awardAmount;
            awardType = badgeArr[i].awardType;
            moodPoints += +badgeArr[i].moodPointsEarned;
        }
        moodPoints = (+moodPoints).toFixed(0);
    }
    let additionalText = "";
    if (awardAmount > 0){
        if (badgeSlctd.earned === true){
            additionalText = "Good job! You've completed both parts of this badge - your " + awardType + 
            " was increased by a total of " + doubleToStringMonthly(awardAmount);
        }else{
            additionalText = "For the part of the badge that you earned your " + awardType +
                " was increased by " + doubleToStringMonthly(awardAmount);
        }
        additionalText += " and your mood points increased by " +
                moodPoints + "."
    }
    const returnObj = {badgeName: badgeName, badgeType: badgeType, 
        badgeAnimation: badgeAnimation, badgeTitle: badgeTitle,
        badgeDesc: badgeDesc, additionalText: additionalText, 
    }
    return returnObj;
}
export default determineBadgeInfo;